import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import Button from '@material-ui/core/Button';
import {Grid, Typography, Container, Box, TextField, FormControl, Checkbox, InputLabel, Select, MenuItem, DialogTitle, DialogContent} from '@material-ui/core';

import {ApplicationBar} from '../../../components/ApplicationBar';

//import Logo from '../../components/Logo';

import {TabbedMenu} from '../../../components/TabbedMenu';

import {UsersListEditor} from './UsersListEditor';
import {GroupsListEditor} from './GroupsListEditor';
import {StatusesListEditor} from './StatusesListEditor';
import {ProfilesListEditor} from './ProfilesListEditor';

import {DevicesList} from './DevicesList';
import {Dialog} from '../../../components/Dialog';
import {AclListEditor} from './AclListEditor';

import {EditUserDialog} from './EditUserDialog';
import {EditGroupDialog} from './EditGroupDialog';
import {EditStatusDialog} from './EditStatusDialog';
import {EditProfileDialog} from './EditProfileDialog';
//import {SelectLang} from '../../components/SelectLang';

import {getBase64ID, getIndexByID, base64toGuid, sortByName, getObjectByID} from '../../../api/helpers'; 
import { EditPasswordPolicyDialog } from '../../components/EditPasswordPolicyDialog';
import { EditLogSettingsDialog } from '../../components/EditLogSettingsDialog';
import { EditDispatcherPermissionsDialog } from '../ServerSettings/EditDispatcherPermissionDialog';
import { EditUserPermissionsDialog } from './EditUserPermissionsDialog';

import { isInteger, isNumber } from '../../../api/validators';
import { DispatchersListEditor } from './DispatchersListEditor';
import { AclDispatchersListEditor } from './AclDispatchersListEditor';

import { DmrUsersListEditor } from './DmrUsersListEditor';
import { EditDmrUserDialog } from './EditDmrUserDialog';
import { SipUsersListEditor } from './SipUsersListEditor';
import { EditSipUserDialog } from './EditSipUserDialog';

import * as dev from '../../../api/dev'
import { EditSipSettingsDialog } from './EditSipSettingsDialog';
import { ScanListEditor } from './ScanListEditor';
import { EditScanListDialog } from './EditScanListDialog';

class NetworkEditor_ extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
            networkData: this.props.networkData,
            networkSettings: this.props.networkSettings,
            errors: {
                Name: false,
                CommandPort: false,
                AudioPort: false,
                VideoPort: false,
                WebSocketPort: false,
                BatteryChargeInterval: false,
                MaxUserConnections: false
            },  
            currentNetorkID: '',
            currentUserID: '',
            currentGroupID: '',
            currentDispatcherID: '',
            currentProfileID: '',
            currentStatusID: '',
            currentScanlistID: '',
            currentDeviceID: '',
            selectedTab: 'users',
            userFilter: '',
            userEditor: {
                action: '', //add|edit
                userID: '',
                user: {}
            },
            groupFilter: '',
            groupEditor: {
                action: '', //add|edit
                groupID: '',
                group: {}
            },
            statusEditor: {
                action: '', //add|edit
                statusID: '',
                status: {}
            },
            scanlistEditor: {
                action: '',
                scanlistID: '',
                scanlist: {} 
            },
            profileEditor: {
                action: '', //add|edit
                statusID: '',
                profile: {}
            },
            passwordPolicyEditor: {
                open: false,
                passwordPolicy: {}
            },
            logSettingsEditor: {
                open: false,
                logSettings: {}
            },
            dispatcherPermissionEditor:{
                open: false,
                permissions: null
            },
            userPermissionEditor:{
                open: false,
                permissions: null
            },
            dmrUserEditor:{
                open: false,
                user: null
            },
            sipUserEditor:{
                open: false,
                user: null
            },
            sipSettingsEditor:{
                open: false,
                settings: null
            }
        }


        this.handleAction = this.handleAction.bind(this)

        this.handleInput = this.handleInput.bind(this)
        this.handleFilterInput = this.handleFilterInput.bind(this)
    }

    componentDidMount(){
        
    }
    componentDidUpdate(){
        if(this.props.networkSettings && !this.state.networkSettings){
            this.setState({
                networkData: this.props.networkData,
                networkSettings: this.props.networkSettings
            })
            console.log('Open network editor')
            console.log(this.props.networkSettings)
        }
    }

    handleNetworkSelect(networkID){
        this.setState({currentNetorkID: networkID})
    }

    handleUserSelect(userID){
        this.setState({currentUserID: userID})
    }

    handleGroupSelect(groupID){
        this.setState({currentGroupID: groupID})
    }

    handleDispatcherSelect(dispatcherID){
        this.setState({currentDispatcherID: dispatcherID})
    }

    handleProfileSelect(profileID){
        this.setState({currentProfileID: profileID})
    }

    handleStatusSelect(statusID){
        this.setState({currentStatusID: statusID})
    }

    handleScanlistSelect(scanlistID){
        this.setState({currentScanlistID: scanlistID})
    }

    handleDeviceSelect(deviceID){
        this.setState({currentDeviceID: deviceID})
    }

    checkLicense(licenseName){
        return this.props.onAction({type: 'LICENSE_CHECK', licenseName: licenseName})
    }

    getUserAcls(userID){
        if(!this.state.networkSettings) return []

        let acls = [], acl;

        let checked = false;
        let rxOnlyChecked = false;
        for(let i=0; i<this.state.networkSettings.Groups.length; i++){
            
            let group = this.state.networkSettings.Groups[i]
            //console.log('group')
            //console.log(group)
            if(userID){
                let users = group.Users ? group.Users.filter(item => item===userID) : []
                let rxUsers = group.RxOnlyUsers ? group.RxOnlyUsers.filter(item => item===userID) : []
                checked = users.length>0 ? true : false;
                rxOnlyChecked = rxUsers.length>0 ? true : false;
                acl = {groupID: group.ID, userID: userID, value: checked, rxOnly: rxOnlyChecked, name: group.Name}
            }else{
                acl = {groupID: group.ID, userID:'', value: null, rxOnly: null, name: group.Name}
            }      
            acls.push(acl);
        }
        return acls
    }

    getGroupAcls(groupID){
        if(!this.state.networkSettings) return []

        let acls = [], acl;

        let groups = this.state.networkSettings.Groups.filter(item => item.ID===groupID)
        let group =  groups.length>0 ? groups[0] : null;

        let checked = false;
        let rxOnlyChecked = false;
        for(let i=0; i<this.state.networkSettings.Users.length; i++){
            let user = this.state.networkSettings.Users[i]
            //console.log('user')
            //console.log(user)
            if(group){
                let users = group.Users ? group.Users.filter(item => item===user.ID) : []
                let rxUsers = group.RxOnlyUsers ? group.RxOnlyUsers.filter(item => item===user.ID) : []
                checked = users.length>0?true:false;
                rxOnlyChecked = rxUsers.length>0 ? true : false;
                acl = {groupID: group.ID, userID: user.ID, value: checked, rxOnly: rxOnlyChecked, name: user.Login +  ' ' +  user.Name}
            }else{
                acl = {groupID: '', userID: user.ID, value: null, rxOnly: null, name: user.Login +  ' ' +  user.Name}
            }      
            acls.push(acl);      
        }
        return acls
    }   

    getDispatcherAcls(dispatcherID){

        if(!this.state.networkSettings) return []

        let acls = [], acl;

        let checked = false;
        for(let i=0; i<this.state.networkSettings.Groups.length; i++){

            let group = this.state.networkSettings.Groups[i]
            //console.log('group')
            //console.log(group)
            if(dispatcherID){
                let dispatchers = group.Dispatchers.filter(item => item===dispatcherID)
                //let rxUsers = group.RxOnlyUsers.filter(item => item===dispatchersID)
                checked = dispatchers.length>0 ? true : false;
                //rxOnlyChecked = rxUsers.length>0 ? true : false;
                acl = {groupID: group.ID, dispatcherID: dispatcherID, value: checked, name: group.Name}
            }else{
                acl = {groupID: group.ID, dispatcherID:'', value: null, name: group.Name}
            }
            acls.push(acl);
        }

        return acls
    }



    getScanlistAcls(ID){
        if(!this.state.networkSettings) return []

        let acls = [], acl;

        let scanlist = getObjectByID(ID, this.state.networkSettings.ScanLists, 'ID')
        //if(!scanlist) return []

        let checked = false;
        let rxOnlyChecked = false;
        for(let i=0; i<this.state.networkSettings.Groups.length; i++){
            
            let group = this.state.networkSettings.Groups[i]
            console.log('group')
            console.log(group)
            if(scanlist){
                let hasGroup = scanlist.Settings.Groups.filter(item => item===group.ID)
                //console.log(hasGroup)
                //console.log('hasGroup')
                //let rxUsers = group.RxOnlyUsers.filter(item => item===userID)

                checked = hasGroup.length>0 ? true : false;
                //rxOnlyChecked = rxUsers.length>0 ? true : false;
                acl = {groupID: group.ID, userID: ID, value: checked, name: group.Name}
            }else{
                acl = {groupID: group.ID, userID: ID, value: null, name: group.Name}
            }
            acls.push(acl);
        }
        //console.log('getScanlistAcls acls')
        //console.log(acls)
        return acls
    }

/*
    handleLogout(){
        if(this.props.onLogout){
            this.props.onLogout()
        }
    }
    */

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        let error = this.validate(event.target.name, val)
        const networkData = {...this.state.networkData, [event.target.name]: val}
        let errors = {...this.state.errors, [event.target.name]: error}
        this.setState({networkData: networkData, ...changed, errors: errors})
    }

    validate(name, value){
        switch(name){
            case 'BatteryChargeInterval':
            case 'CommandPort':
            case 'AudioPort':
            case 'VideoPort':
            case 'MaxUserConnections':
                return isInteger(value) ? false : this.props.t('IsNotInteger')
                break   

            case 'WebSocketPort':
                return !value || (isInteger(value) && Number(value)>0) ? false : this.props.t('IsNotInteger')
                break


            case 'Name':
                return value ? false : this.props.t('NameIsEmpty')
                break
            
            default:
                console.log('validate')
                console.log({name: name, value: value})
        }
        
        return false
    }

    checkForm(){
        let check = true
        for(var i in this.state.errors){
            console.log('check '+i)
            var v = this.validate(i, this.state.networkData[i])
            console.log(v)
            if(v){
                check = false
            }
        }
        return check
    }

    handleFilterInput(event){
        const val =  event.target.value
        console.log('handleFilterInput')
        console.log(event.target.name +' = ' +val)

        this.setState({[event.target.name]: val})
    }


    handleTabClick(tab){
        this.setState({selectedTab: tab});
    }

    handleButtonSave(){
        if(this.checkForm()){
            //console.log('NETWORK_EDITOR_SAVE')
            //console.log(this.state.networkData)
            //console.log(this.state.networkSettings)
            this.props.onAction({
                type:'NETWORK_EDITOR_SAVE', 
                networkData: this.state.networkData,
                networkSettings: this.state.networkSettings
            })
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleButtonCancel(){
        this.props.onAction({type:'NETWORK_EDITOR_CLOSE'})
    }

    //acl editor
    handleUserAclChange(aclName, index, groupID, userID, checked){
        //clone object
        //console.log('handleUserAclChange '+aclName+ '; checked'+checked)
        let networkSettings = {...this.state.networkSettings};
        for(let i=0; i<networkSettings.Groups.length; i++){
            let group = networkSettings.Groups[i]
            if(group.ID===groupID){
                if(checked){
                    //add user
                    //console.log('group[aclName]')
                    //console.log(group[aclName])
                    if(group[aclName]===undefined) group[aclName] = []
                    group[aclName].push(userID)
/*
                    if(aclName=='Users'){
                        group.Users.push(userID)
                    }else if(aclName=='RxOnlyUsers'){
                        group.RxOnlyUsers.push(userID)
                    }*/
                }else{
                    //remove user
                    //console.log('remove user ' + userID)
                    for(let j=0; j<group[aclName].length; j++){
                        if(group[aclName][j]===userID){
                            //group.Users.splice(j, 1)

                            group[aclName].splice(j, 1)
                            break 
                        }
                    }
                }
                break
            }
        }

        this.setState({networkSettings: networkSettings})

    }

    handleDispatcherAclChange(aclName, index, groupID, dispatcherID, checked){
        let networkSettings = {...this.state.networkSettings};
        for(let i=0; i<networkSettings.Groups.length; i++){
            let group = networkSettings.Groups[i]
            if(group.ID===groupID){
                if(checked){
                    //add user
                    //console.log('raddemove item ' + aclName + ' ' + dispatcherID)
                    if(group[aclName]===undefined) group[aclName] = []
                    group[aclName].push(dispatcherID)
/*
                    if(aclName=='Users'){
                        group.Users.push(userID)
                    }else if(aclName=='RxOnlyUsers'){
                        group.RxOnlyUsers.push(userID)
                    }*/
                }else{
                    //remove user
                    console.log('remove item ' + aclName + ' ' + dispatcherID)
                    for(let j=0; j<group[aclName].length; j++){
                        if(group[aclName][j]===dispatcherID){
                            //group.Users.splice(j, 1)

                            group[aclName].splice(j, 1)
                            break 
                        }
                    }
                }
                break
            }
        }

        this.setState({networkSettings: networkSettings})

    }

    handleScanlistAclChange(aclName, index, groupID, scanlistID, checked){
        //clone object
        //console.log('handleUserAclChange '+aclName+ '; checked'+checked)
        let networkSettings = {...this.state.networkSettings};

        //console.log('handleScanlistAclChange')
        //console.log(groupID)
        //console.log(scanlistID)
        //console.log(networkSettings.ScanLists)

        const scanlistIndex = getIndexByID(scanlistID, networkSettings.ScanLists, 'ID')
        //console.log('scanlistIndex')
        //console.log(scanlistIndex)

        let aclIndex = networkSettings.ScanLists[scanlistIndex].Settings.Groups.indexOf(groupID)
        //console.log('group acl index')
        //console.log(aclIndex)

        if(checked && aclIndex<0){
            networkSettings.ScanLists[scanlistIndex].Settings.Groups.push(groupID)
        }else if(!checked && aclIndex>=0){
            networkSettings.ScanLists[scanlistIndex].Settings.Groups.splice(aclIndex, 1)
        }

        this.setState({networkSettings: networkSettings})

        //console.log('set state networkSettings')
        //console.log(networkSettings)

    }


    handleAction(action){

        //console.log('NetworkEditor action: ' + action.type)

        switch(action.type){
            case 'SHOW_PASSWORD_POLICY_DIALOG':
                this.setState({
                    passwordPolicyEditor:{
                        open: true,
                        passwordPolicy: this.state.networkData.PasswordPolicy
                    }
                })
                break;

            case 'PASSWORD_POLICY_EDITOR_SAVE':{
                let {passwordPolicy} = action
                let networkData = {...this.state.networkData}
                networkData.PasswordPolicy = passwordPolicy
                this.setState({networkData: networkData, 
                              passwordPolicyEditor:{open:false, passwordPolicy: {}}
                })
                break
            }

            case 'PASSWORD_POLICY_EDITOR_CLOSE':
                console.log('PASSWORD_POLICY_EDITOR_CLOSE')
                this.setState({passwordPolicyEditor:{
                    open:false,
                    passwordPolicy: {}
                }})
                break


            case 'SHOW_LOG_SETTINGS_DIALOG':{
                this.setState({
                    logSettingsEditor:{
                        open: true,
                        logSettings: {
                            ClearData: this.state.networkData.ClearData,
                            ClearDataDays: this.state.networkData.ClearDataDays,
                            ClearRecordingDays: this.state.networkData.ClearRecordingDays,
                            ClearRecordings: this.state.networkData.ClearRecordings
                        }
                    }
                })
                break
            }

            case 'LOG_SETTINGS_EDITOR_SAVE':{
                let {logSettings} = action
                let networkData = {...this.state.networkData, ...logSettings}
                
                this.setState({
                    networkData: networkData, 
                    logSettingsEditor:{open:false, logSettings: {}}
                })
                break
            }

            case 'LOG_SETTINGS_EDITOR_CLOSE':{
                console.log('PASSWORD_POLICY_EDITOR_CLOSE')
                this.setState({
                    logSettingsEditor:{
                        open:false,
                        logSettings: {}
                    }
                })
                break
            }


            case 'SHOW_DISPATCHER_PERMISSIONS_DIALOG':{
                //console.log('this.state.networkData.AllowedOps')
                //console.log(this.state.networkData.AllowedOps)
                const p1 = this.state.networkData.AllowedOps
                const p2 = this.state.networkData.AllowedOps2!==undefined ? this.state.networkData.AllowedOps2 : 0
                const permissions = p1 + p2 * 4294967296

                const indoorTrackingEnabled = this.checkLicense('IndoorTracking')
                const monitoringEnabled = this.checkLicense('Monitoring')
                
                //console.log('indoorTrackingEnabled = '+ (indoorTrackingEnabled?'true':'false')) 
                this.setState({
                    dispatcherPermissionEditor:{
                        open: true,
                        monitoringEnabled: monitoringEnabled,
                        indoorTrackingEnabled: indoorTrackingEnabled,
                        permissions: permissions //this.state.networkData.AllowedOps
                    }
                })
                break
            }

            case 'DISPATCHER_PERMISSIONS_EDITOR_CLOSE':{
                this.setState({
                    dispatcherPermissionEditor:{
                        open: false,
                        permissions: null
                    }
                })
                break
            }

            case 'DISPATCHER_PERMISSIONS_EDITOR_SAVE':{
                let changed = !this.state.changed ? {changed: true} : {}

                this.setState({permissionsDialogOpen: false})
                const networkData = {...this.state.networkData}

                let permissions_1 = action.permissions % 4294967296
                let permissions_2 = Math.trunc(action.permissions/4294967296)
                //console.log('permissions_1='+permissions_1)
                //console.log('permissions_2='+permissions_2)

                networkData.AllowedOps = permissions_1
                networkData.AllowedOps2 = permissions_2

                this.setState({
                    networkData: networkData, 
                    ...changed,
                    dispatcherPermissionEditor:{
                        open: false,
                        permissions: null
                    }
                })
                break;
            }


            case 'SHOW_USER_PERMISSIONS_DIALOG':{
                //console.log('this.state.networkData.AllowedOps')
                //console.log(this.state.networkData.AllowedOps)
                //console.log(this.state.networkData.AllowedOps2)
                const p1 = this.state.networkData.AllowedOps
                const p2 = this.state.networkData.AllowedOps2!==undefined ? this.state.networkData.AllowedOps2 : 0
                const permissions = p1 + p2 * 4294967296
                //const permissions = this.state.networkData.AllowedOps + this.state.networkData.AllowedOps2 * 4294967296
                //console.log('permissions = '+permissions)
                this.setState({
                    userPermissionEditor:{
                        open: true,
                        permissions: permissions //this.state.networkData.AllowedOps
                    }
                })
                break
            }

            case 'USER_PERMISSIONS_EDITOR_CLOSE':{
                this.setState({
                    userPermissionEditor:{
                        open: false,
                        permissions: null
                    }
                })
                break
            }

            case 'USER_PERMISSIONS_EDITOR_SAVE':{
                let changed = !this.state.changed ? {changed: true} : {}

                this.setState({permissionsDialogOpen: false})
                const networkData = {...this.state.networkData}

                let permissions_1 = action.permissions % 4294967296
                let permissions_2 = Math.trunc(action.permissions/4294967296)
                //console.log('USER_PERMISSIONS_EDITOR_SAVE')
                //console.log('permissions_1='+permissions_1)
                //console.log('permissions_2='+permissions_2)

                networkData.AllowedOps = permissions_1
                networkData.AllowedOps2 = permissions_2

                this.setState({
                    networkData: networkData, 
                    ...changed,
                    userPermissionEditor:{
                        open: false,
                        permissions: null
                    }
                })
                break;
            }

            case 'SET_DISPATCHER_ALL_GROUPS':{
                let networkSettings = {...this.state.networkSettings}
                let index = getIndexByID(action.id, networkSettings.NetworkDispatchers)
                if(index!==null){
                    console.log(networkSettings.NetworkDispatchers[index])
                    networkSettings.NetworkDispatchers[index]['AllGroups'] = action.value 
                }else{
                    console.error('index not found: NetworkDispatchers ' + action.id)
                }

                this.setState({networkSettings: networkSettings})
                break
            }

            default: 
                this.props.onAction(action)
        }

        
    }
    
    handleUserEditorAction(action){

        switch(action.type){
            case 'USER_EDITOR_SAVE': {
                    let user = {...action.user}
                    let networkSettings = {...this.state.networkSettings}
                    if(!user.ID){
                        user.ID = getBase64ID()
                    }
                    let userIndex = getIndexByID(user.ID, networkSettings.Users)
                    if(userIndex===null){
                        networkSettings.Users.push(user);
                    }else{
                        networkSettings.Users[userIndex] = user
                    }
                    this.setState({networkSettings: networkSettings, userEditor: {action:'', userID:'', user:{}}})
                }
                break;

            case 'USER_EDITOR_CLOSE':
                this.setState({userEditor: {action:'', userID:'', user:{}}})
                break;

            case 'USER_EDITOR_OPEN_EDIT': {
                    
                    let users = this.state.networkSettings.Users.filter(item => item.ID===action.userID)
                    let user = users[0]

                    console.log('this.props.serverSettings')
                    console.log(this.props.serverSettings)

                    //let fieldTemplates = this.props.serverSettings.FieldTemplates.filter((item)=>{return item.Type===3})
                    //console.log('fieldTemplates')
                    //console.log(fieldTemplates)

                    this.setState({userEditor: {
                        action: 'edit', //add|edit
                        userID: action.userID,
                        user: user,
                        passwordPolicy: this.state.networkData.PasswordPolicy//,
                        //fieldTemplates: fieldTemplates
                    }})
                }
                break
            case 'USER_EDITOR_OPEN_ADD': 
                this.setState({userEditor: {
                    action: 'add', //add|edit
                    userID: action.userID,
                    user: {}
                }})
                break
            case 'USER_EDITOR_DELETE': {
                    let networkSettings = {...this.state.networkSettings}
                    const userIndex = getIndexByID(action.userID, networkSettings.Users)
                    if(userIndex!==null){
                        networkSettings.Users.splice(userIndex, 1)
                        this.setState({networkSettings: networkSettings})   
                    }
                }
                break;
            case 'USER_EDITOR_INPUT':{
                    const {event, userID} = action;
                    let networkSettings = {...this.state.networkSettings}
                    const userIndex = getIndexByID(userID, networkSettings.Users)
                    if(userIndex!==null){
                        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
                        const user = {...networkSettings.Users[userIndex], [event.target.name]: val}
                        networkSettings.Users[userIndex] = user
                        this.setState({networkSettings: networkSettings})
                    }
                }
                break;

            default:
                this.props.onAction(action)
        }
    }

    handleGroupEditorAction(action){

        switch(action.type){
            case 'GROUP_EDITOR_SAVE': {
                    let group = {...action.group}
                    let networkSettings = {...this.state.networkSettings}
                    //if(!group.ID){
                    //    group.ID = getBase64ID()
                    //}
                    let groupIndex = getIndexByID(group.ID, networkSettings.Groups)
                    if(groupIndex===null){
                        if(group.Users===undefined){
                            //group.Users = []
                            //group.DMRGroupID = 0,​
                            //group.DMRNetworkID = "AAAAAAAAAAAAAAAAAAAAAA=="
                            //group.DMRSlot = 0
                        }
                        networkSettings.Groups.push(group);
                    }else{
                        networkSettings.Groups[groupIndex] = group
                    }
                    this.setState({networkSettings: networkSettings, groupEditor: {action:'', groupID:'', group:{}}})
                }
                break;

            case 'GROUP_EDITOR_CLOSE':
                this.setState({groupEditor: {action:'', groupID:'', group:{}}})
                break;

            case 'GROUP_EDITOR_OPEN_EDIT': {
                    let groups = this.state.networkSettings.Groups.filter(item => item.ID===action.groupID)
                    let group = groups[0]
                    this.setState({groupEditor: {
                        action: 'edit', //add|edit
                        groupID: action.groupID,
                        group: group
                    }})
                }
                break
            case 'GROUP_EDITOR_OPEN_ADD': 
                this.setState({groupEditor: {
                    action: 'add', //add|edit
                    groupID: action.groupID,
                    group: { //group defaults
                        ID: getBase64ID(),
                        Users: [],
                        Dispatchers: [],
                        Devices: [],
                        RxOnlyUsers: [],
                        DMRGroupID: 0, 
                        DMRNetworkID: "AAAAAAAAAAAAAAAAAAAAAA==",
                        DMRSlot: 0,
                        Priority: 0,
                        AllCall: 0,
                        Broadcast: 0,
                        Emergency: 0,
                    }
                }})
                break
            case 'GROUP_EDITOR_DELETE': {
                    let networkSettings = {...this.state.networkSettings}
                    const groupIndex = getIndexByID(action.groupID, networkSettings.Groups)
                    if(groupIndex!==null){
                        networkSettings.Groups.splice(groupIndex, 1)
                        this.setState({networkSettings: networkSettings})   
                    }
                }
                break;

            case 'GROUP_EDITOR_INPUT':{
                    const {event, groupID} = action;
                    let networkSettings = {...this.state.networkSettings}
                    const groupIndex = getIndexByID(groupID, networkSettings.Groups)
                    if(groupIndex!==null){
                        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
                        const group = {...networkSettings.Groups[groupIndex], [event.target.name]: val}
                        networkSettings.Groups[groupIndex] = group
                        this.setState({networkSettings: networkSettings})
                    }
                }
                break;

            default:
                this.props.onAction(action)
        }
    }


    handleStatusEditorAction(action){

        switch(action.type){
            case 'STATUS_EDITOR_SAVE': {
                    let status = {...action.status}
                    let networkSettings = {...this.state.networkSettings}
                    if(!status.ID){
                        status.ID = getBase64ID()
                    }
                    let statusIndex = getIndexByID(status.ID, networkSettings.Statuses)
                    if(statusIndex===null){
                        networkSettings.Statuses.push(status);
                    }else{
                        networkSettings.Statuses[statusIndex] = status
                    }
                    this.setState({networkSettings: networkSettings, statusEditor: {action:'', statusID:'', status:{}}})
                }
                break;

            case 'STATUS_EDITOR_CLOSE':
                this.setState({statusEditor: {action:'', statusID:'', status:{}}})
                break;

            case 'STATUS_EDITOR_OPEN_EDIT': {
                    let statuses = this.state.networkSettings.Statuses.filter(item => item.ID===action.statusID)
                    let status = statuses[0]
                    this.setState({statusEditor: {
                        action: 'edit', //add|edit
                        statusID: action.statusID,
                        status: status
                    }})
                }
                break
            case 'STATUS_EDITOR_OPEN_ADD': 
                this.setState({statusEditor: {
                    action: 'add', //add|edit
                    statusID: action.statusID,
                    status: {}
                }})
                break
            case 'STATUS_EDITOR_DELETE': {
                    let networkSettings = {...this.state.networkSettings}
                    const statusIndex = getIndexByID(action.statusID, networkSettings.Statuses)
                    if(statusIndex!==null){
                        networkSettings.Statuses.splice(statusIndex, 1)
                        this.setState({networkSettings: networkSettings})   
                    }
                }
                break;

            case 'STATUS_EDITOR_INPUT':{
                    const {event, statusID} = action;
                    let networkSettings = {...this.state.networkSettings}
                    const statusIndex = getIndexByID(statusID, networkSettings.Statuses)
                    if(statusIndex!==null){
                        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
                        const status = {...networkSettings.Statuss[statusIndex], [event.target.name]: val}
                        networkSettings.Statuses[statusIndex] = status
                        this.setState({networkSettings: networkSettings})
                    }
                }
                break;

            default:
                this.props.onAction(action)
        }
    }


    handleScanListEditorAction(action){

        switch(action.type){

            case 'SCANLIST_EDITOR_OPEN_EDIT': {

                //alert('SCANLIST_EDITOR_OPEN_EDIT')
                
                let scanlists = this.state.networkSettings.ScanLists.filter(item => item.ID===action.itemID)
                let scanlist = scanlists[0]

                //console.log('scanlist')

                this.setState({scanlistEditor: {
                    action: 'edit', //add|edit
                    scanlistID: action.itemID,
                    scanlist: scanlist
                }})
                break
            }

            case 'SCANLIST_EDITOR_OPEN_ADD': {
                this.setState({scanlistEditor: {
                    action: 'add', //add|edit
                    scanlistID: action.itemID,
                    scanlist: {}
                }})
                break
            }

            case 'SCANLIST_EDITOR_SAVE': {
                let scanlist = {...action.scanlist}
                let networkSettings = {...this.state.networkSettings}
                if(!scanlist.ID){
                    scanlist.ID = getBase64ID()
                }
                if(!scanlist.Settings){
                    scanlist.Settings = {
                        Groups: []
                    }
                }
                let scanlistIndex = getIndexByID(scanlist.ID, networkSettings.ScanLists, "ID")
                if(scanlistIndex===null){
                    networkSettings.ScanLists.push(scanlist)
                }else{
                    networkSettings.ScanLists[scanlistIndex] = scanlist
                }
                console.log('networkSettings');
                console.log(networkSettings);
                this.setState({
                    networkSettings: networkSettings, 
                    scanlistEditor: {action:'', scanlistID:'', scanlist:{}}
                })
                break
            }

            case 'SCANLIST_EDITOR_DELETE': {
                console.log('action')
                console.log(action)
                let networkSettings = {...this.state.networkSettings}
                const scanlistIndex = getIndexByID(action.itemID, networkSettings.ScanLists, "ID")
                if(scanlistIndex!==null){
                    networkSettings.ScanLists.splice(scanlistIndex, 1)
                    this.setState({networkSettings: networkSettings})   
                }
                break
            }

            case 'SCANLIST_EDITOR_CLOSE': {
                this.setState({scanlistEditor: {action:'', scanlistID:'', scanlist:{}}})
                break
            }

            default:
                this.props.onAction(action)
        }

    }

    handleProfileEditorAction(action){

        switch(action.type){
            case 'PROFILE_EDITOR_SAVE': {
                let profile = {...action.profile}
                let networkSettings = {...this.state.networkSettings}
                if(!profile.ProfileID){
                    profile.ProfileID = getBase64ID()
                }
                let profileIndex = getIndexByID(profile.ProfileID, networkSettings.Profiles, "ProfileID")
                if(profileIndex===null){
                    networkSettings.Profiles.push(profile);
                }else{
                    networkSettings.Profiles[profileIndex] = profile
                }
                this.setState({networkSettings: networkSettings, profileEditor: {action:'', profileID:'', profile:{}}})
                break;
            }
                

            case 'PROFILE_EDITOR_CLOSE':
                this.setState({profileEditor: {action:'', profileID:'', profile:{}}})
                break;

            case 'PROFILE_EDITOR_OPEN_EDIT': {
                let profiles = this.state.networkSettings.Profiles.filter(item => item.ProfileID===action.profileID)
                let profile = profiles[0]

                this.setState({profileEditor: {
                    action: 'edit', //add|edit
                    profileID: action.profileID,
                    profile: profile,
                    emergencyGroups: this.getProfileEmergencyGroups(),
                    receivers: this.getProfileReceivers()
                }})
                break
            }
                
            case 'PROFILE_EDITOR_OPEN_ADD': 
                this.setState({profileEditor: {
                    action: 'add', //add|edit
                    profileID: action.profileID,
                    profile: {},
                    emergencyGroups: this.getProfileEmergencyGroups(),
                    receivers: this.getProfileReceivers()
                }})
                break
                
            case 'PROFILE_EDITOR_DELETE': {
                let networkSettings = {...this.state.networkSettings}
                const profileIndex = getIndexByID(action.profileID, networkSettings.Profiles, "ProfileID")
                if(profileIndex!==null){
                    networkSettings.Profiles.splice(profileIndex, 1)
                    this.setState({networkSettings: networkSettings})   
                }
                break
            }

            case 'PROFILE_EDITOR_INPUT':{
                const {event, profileID} = action;
                let networkSettings = {...this.state.networkSettings}
                const profileIndex = getIndexByID(profileID, networkSettings.Profiles, "ProfileID")
                if(profileIndex!==null){
                    const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
                    const profile = {...networkSettings.Profiles[profileIndex], [event.target.name]: val}
                    networkSettings.Profiles[profileIndex] = profile
                    this.setState({networkSettings: networkSettings})
                }
                break;
            }
                
            default:
                this.props.onAction(action)
        }
    }

    handleDmrUserEditorAction(action){
        //console.log('handleDmrUserEditorAction')
        //console.log(action)     

        switch(action.type){
            case 'DMR_USER_EDITOR_OPEN_EDIT':{

                let users = this.state.networkSettings.DmrUsers.filter(item => item.ID===action.userID)
                let user = users[0]

                console.log('this.props.serverSettings')
                console.log(this.props.serverSettings)

                this.setState({dmrUserEditor: {
                    open: true,
                    action: 'edit', //add|edit
                    user: user
                }})

                break
            }

            case 'DMR_USER_EDITOR_OPEN_ADD':{
                this.setState({dmrUserEditor: {
                    open: true,
                    action: 'add', //add|edit
                    user: {}
                }})
                break
            }

            case 'DMR_USER_EDITOR_SAVE':{
                let user = {...action.user}
                let networkSettings = {...this.state.networkSettings}
                if(!user.ID){
                    user.ID = getBase64ID()
                }
                let userIndex = getIndexByID(user.ID, networkSettings.DmrUsers)
                if(userIndex===null){
                    networkSettings.DmrUsers.push(user);
                }else{
                    networkSettings.DmrUsers[userIndex] = user
                }
                this.setState({networkSettings: networkSettings, dmrUserEditor: {action:'', userID:'', user:null}})

                break
            }

            case 'DMR_USER_EDITOR_DELETE':{
                let networkSettings = {...this.state.networkSettings}
                    const userIndex = getIndexByID(action.userID, networkSettings.DmrUsers)
                    if(userIndex!==null){
                        networkSettings.DmrUsers.splice(userIndex, 1)
                        this.setState({networkSettings: networkSettings})   
                    }
                break
            }

            case 'DMR_USER_EDITOR_CLOSE':{
                this.setState({dmrUserEditor: {
                    open: false,
                    action: '', //add|edit
                    user: null
                }})
                break
            }

            default:
                this.props.onAction(action)
        }

    }

    handleLimitDmrUsersChnge(event){
        //let changed = !this.state.changed ? {changed: true} : {}
        let val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        this.setState({networkData: {...this.state.networkData, LimitDmrUsers: val}})
    }


    handleSipUserEditorAction(action){

        switch(action.type){
            case 'SIP_USER_EDITOR_OPEN_EDIT':{

                let users = this.state.networkSettings.SipUsers.filter(item => item.ID===action.userID)
                let user = users[0]

                console.log('this.props.serverSettings')
                console.log(this.props.serverSettings)

                this.setState({sipUserEditor: {
                    open: true,
                    action: 'edit', //add|edit
                    user: user
                }})

                break
            }

            case 'SIP_USER_EDITOR_OPEN_ADD':{
                this.setState({sipUserEditor: {
                    open: true,
                    action: 'add', //add|edit
                    user: {}
                }})
                break
            }

            case 'SIP_USER_EDITOR_SAVE':{
                let user = {...action.user}
                let networkSettings = {...this.state.networkSettings}
                if(!user.ID){
                    user.ID = getBase64ID()
                }
                let userIndex = getIndexByID(user.ID, networkSettings.SipUsers)
                if(userIndex===null){
                    networkSettings.SipUsers.push(user);
                }else{
                    networkSettings.SipUsers[userIndex] = user
                }
                this.setState({networkSettings: networkSettings, sipUserEditor: {action:'', userID:'', user:null}})

                break
            }

            case 'SIP_USER_EDITOR_DELETE':{
                let networkSettings = {...this.state.networkSettings}
                    const userIndex = getIndexByID(action.userID, networkSettings.SipUsers)
                    if(userIndex!==null){
                        networkSettings.SipUsers.splice(userIndex, 1)
                        this.setState({networkSettings: networkSettings})   
                    }
                break
            }

            case 'SIP_USER_EDITOR_CLOSE':{
                this.setState({sipUserEditor: {
                    open: false,
                    action: '', //add|edit
                    user: null
                }})
                break
            }


            default:
                this.props.onAction(action)
        }

    }

    handleSipSettingsEditorAction(action){


        console.log(action)

        switch(action.type){
            case 'SIP_SETTINGS_EDITOR_OPEN':{
                console.log('this.state.networkData')
                console.log(this.state.networkData)
                let settings = this.state.networkData.SipGateway

                this.setState({sipSettingsEditor: {
                    open: true,
                    settings: settings
                }})

                break
            }

            case 'SIP_SETTINGS_EDITOR_CLOSE':{
                this.setState({sipSettingsEditor: {
                    open: false,
                    settings: null
                }})
                break
            }

            case 'SIP_SETTINGS_EDITOR_SAVE':{
                let settings = action.settings
                let networkData = {...this.state.networkData, SipGateway: settings}

                this.setState({
                    sipSettingsEditor: {
                        open: false,
                        settings: null
                    },
                    networkData: networkData
                })
                break
            }

        }

    }

    getProfileEmergencyGroups(){
        let emergencyGroups = this.state.networkSettings.Groups.filter(
            item => item.Emergency  
        ).sort(sortByName);
        return emergencyGroups
    }

    getProfileReceivers(){
        let receivers = [
            ...this.state.networkSettings.NetworkDispatchers.map(item=>{
                return {ID: base64toGuid(item.ID), Name:item.Name, Type:10}
            }),
            ...this.state.networkSettings.Groups.map(item=>{
                return {ID: base64toGuid(item.ID), Name:item.Name, Type:4}
            }),
            ...this.state.networkSettings.Users.map(item=>{
                return {ID: base64toGuid(item.ID), Name:item.Name, Type:3}
            }),
        ];      

        //console.log(receivers);
        return receivers;
    }

    render(){
        const {t} = this.props

        let statusMessage = ''
        if(this.props.statusMessage){
            statusMessage = (
            <Typography align="center" color={this.props.statusError ? "error" : "default"}>
                {this.props.statusMessage}
            </Typography>
            );
        }
        

        //networkSettings
        let networkData = this.state.networkData
        let networkSettings = this.state.networkSettings

        console.log('networkData')
        console.log(networkData)

        console.log('networkSettings')
        //networkSettings = null
        console.log(networkSettings)

        let users = networkSettings && networkSettings.Users ? networkSettings.Users: [];
        let groups = networkSettings && networkSettings.Groups ? networkSettings.Groups: [];
        let dispatchers = networkSettings && networkSettings.NetworkDispatchers ? networkSettings.NetworkDispatchers: [];
        let devices = networkSettings && networkSettings.Devices ? networkSettings.Devices: [];
        let statuses = networkSettings && networkSettings.Statuses ? networkSettings.Statuses: [];
        let scanlists = networkSettings && networkSettings.ScanLists ? networkSettings.ScanLists: [];
        let profiles = networkSettings && networkSettings.Profiles ? networkSettings.Profiles: [];
        
        

        let list = ''
        let panel = ''
     
        switch(this.state.selectedTab){
            case 'users': 

                //console.log('this.props.serverSettings')
                //console.log(this.props.serverSettings)

                let fieldTemplates = this.props.serverSettings ? this.props.serverSettings.FieldTemplates.filter((item)=>{return item.Type===3}) : null
                //console.log('fieldTemplates')
                //console.log(fieldTemplates)

                let fieldsTemplate = fieldTemplates ? fieldTemplates.find(item=>item.ID===this.state.networkData.UserExtendedFieldsTemplateID) : null

                //console.log('fieldsTemplate')
                //console.log(fieldsTemplate)
                //console.log('this.state render networkEditor')
                //console.log(this.state)

                const userAcls = this.getUserAcls(this.state.currentUserID); 
                const userDialog = this.state.userEditor.action?(
                    <EditUserDialog open={this.state.userEditor.action!==''}
                        {...this.state.userEditor} 
                        passwordPolicy={this.state.networkData.PasswordPolicy}
                        devices={this.state.networkSettings.Devices}
                        fieldsTemplate={fieldsTemplate}
                        scanlists={this.state.networkSettings.ScanLists}
                        profiles={this.state.networkSettings.Profiles}
                        onAction={this.handleUserEditorAction.bind(this)}/>
                ):'';


                list = (
                    <>
                    <Grid container style={{marginBottom:5}}>
                        <Grid item xs={3} align="left">
                            <TextField name="userFilter" 
                                margin='normal'
                                variant2="outlined"
                                size="small"
                                style={{width: '90%', margin:0}}
                                label={t('FilterUsers')}
                                autoComplete="new-password"
                                error={false}
                                value={this.state.userFilter}
                                onChange={this.handleFilterInput}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl style={{width:'90%', margin:'auto'}}>
                                <InputLabel htmlFor="UserExtendedFieldsTemplateID">{t('FieldTemplate')}</InputLabel>
                                <Select
                                    variant2="outlined"
                                    value={this.state.networkData.UserExtendedFieldsTemplateID}
                                    onChange={this.handleInput}
                                    inputProps={{
                                        name: 'UserExtendedFieldsTemplateID',
                                        id: 'UserExtendedFieldsTemplateID',
                                    }}
                                    >
                                    {fieldTemplates ? fieldTemplates.map(item=>
                                        <MenuItem key={item.ID} value={item.ID}>{item.Name}</MenuItem>
                                    ) : null}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={5} align="right">
                            <FormControl style={{width:'90%', margin:'auto'}}>
                                <label style={{fontSize:'x-small'}}>
                                    <Checkbox color="primary"
                                        checked={this.state.networkData.LimitUserConnections}
                                        onChange={this.handleInput}
                                        name="LimitUserConnections"
                                        />
                                        {t('LimitNumberOfUserConnectionsTo')}
                                </label>
                            </FormControl>
                        </Grid>
                        <Grid item xs={1} align="left">
                            <TextField name="MaxUserConnections"
                                id="MaxUserConnections" 
                                margin='normal'
                                hiddenLabel
                                size="small"
                                disabled={!this.state.networkData.LimitUserConnections}
                                style={{width: '2em', margin:0, marginLeft: '1em', display: "flex", alignItems: "center"}}
                                autoComplete="new-password"
                                error={this.state.errors.MaxUserConnections!==false}
                                value={this.state.networkData.MaxUserConnections}
                                onChange={this.handleInput}
                            />
                        </Grid>
                    </Grid>
                    <Grid justifyContent="flex-start" container style={{minHeight:'30vh'}}>
                        <Grid xs={6} key="1" item style={{}}>
                            <UsersListEditor users={users}
                                    filter={this.state.userFilter}
                                    selectedUserID={this.state.currentUserID}
                                    onUserSelect={this.handleUserSelect.bind(this)}
                                    onAction={this.handleUserEditorAction.bind(this)} />
                            {userDialog}
                        </Grid>        
                        <Grid xs={6} key="2" item style={{paddingLeft:'1em'}}>
                            <AclListEditor items={userAcls} title={t('GroupName')} 
                                onChange={this.handleUserAclChange.bind(this)} />
                        </Grid>
                    </Grid>
                    </>
                );
                break;

            case 'groups':

                console.log('this.props.serverSettings')
                console.log(this.props.serverSettings)
                
                const groupAcls = this.getGroupAcls(this.state.currentGroupID); 
                const groupDialog = this.state.groupEditor.action?(
                    <EditGroupDialog open={this.state.groupEditor.action!==''}
                        externalNetworks={this.props.serverSettings.ExternalNetworks}
                        {...this.state.groupEditor} 
                        onAction={this.handleGroupEditorAction.bind(this)}/>
                ):'';

                list = (
                    <>
                    <Grid container style={{marginBottom:5}}>
                        <Grid item xs={4} align="left">
                            <TextField name="groupFilter" 
                                margin='normal'
                                variant2="outlined"
                                size="small"
                                style={{width: '90%', margin:0}}
                                label={t('FilterGroups')}
                                autoComplete="new-password"
                                error={false}
                                value={this.state.groupFilter}
                                onChange={this.handleFilterInput}
                            />
                        </Grid>
                    </Grid>
                    <Grid justifyContent="flex-start" container style={{minHeight:'30vh'}}>
                        <Grid xs={6} key="1" item style={{}}>
                            <GroupsListEditor groups={groups} 
                                filter={this.state.groupFilter}
                                selectedGroupID={this.state.currentGroupID}
                                onItemSelect={this.handleGroupSelect.bind(this)}
                                onAction={this.handleGroupEditorAction.bind(this)} /> 
                            {groupDialog}
                        </Grid>
                        <Grid xs={6} key="2" item style={{paddingLeft:'1em'}}>
                            <AclListEditor items={groupAcls} title={t('UserName')}
                                onChange={this.handleUserAclChange.bind(this)} />
                        </Grid>
                    </Grid>
                    </>
                );
                break;

            case 'dispatchers':{

                dispatchers = this.state.networkSettings.NetworkDispatchers

                //const dispatchersAcls = []

                const dispatchersAcls = this.getDispatcherAcls(this.state.currentDispatcherID); 
                
                const currentDispatcher = getObjectByID(this.state.currentDispatcherID, dispatchers)

                console.log('dispatchers')
                console.log(dispatchers)
                console.log('dispatchersAcls')
                console.log(dispatchersAcls)

                const allGroups = currentDispatcher ? currentDispatcher.AllGroups : false;

                list = (
                    <Grid justifyContent="flex-start" container style={{minHeight:'30vh'}}>
                        <Grid xs={6} key="1" item style={{}}>
                            <DispatchersListEditor 
                                dispatchers={dispatchers} onAction={this.handleAction}
                                selectedID={this.state.currentDispatcherID}
                                onSelect={this.handleDispatcherSelect.bind(this)} />
                        </Grid>
                        <Grid xs={6} key="2" item style={{paddingLeft:'1em'}}>
                            <AclDispatchersListEditor
                                disabled={allGroups}
                                items={dispatchersAcls} 
                                title={t('GroupName')} 
                                onChange={this.handleDispatcherAclChange.bind(this)} />
                        </Grid>
                    </Grid>
                )
                break
            }


            case 'statuses':
                const statusDialog = this.state.statusEditor.action?(
                    <EditStatusDialog open={this.state.statusEditor.action!==''}
                        {...this.state.statusEditor} 
                        onAction={this.handleStatusEditorAction.bind(this)}/>
                ):'';
                //console.log(statuses)
                list = (
                    <>
                    <StatusesListEditor items={statuses} 
                        selectedItemID={this.state.currentStatusID}
                        onItemSelect={this.handleStatusSelect.bind(this)}
                        onAction={this.handleStatusEditorAction.bind(this)} />  
                    {statusDialog}
                    </>
                )
                break;

            case 'devices':
                list = (
                    <DevicesList items={devices} 
                        selectedItemID={this.state.currentDeviceID}
                        onItemSelect={this.handleDeviceSelect.bind(this)}/>  
                )
                break;

            case 'scanlists':{

                //const groupAcls = this.getGroupAcls(this.state.currentGroupID); 
                //const userAcls = this.getUserAcls(this.state.currentUserID); 
                const scanlistAcls = this.getScanlistAcls(this.state.currentScanlistID);
                console.log('scanlistAcls '+this.state.currentScanlistID)
                console.log(scanlistAcls)
                //const scanlistDialog = '' 

                const scanlistDialog = this.state.scanlistEditor.action?(
                    <EditScanListDialog open={this.state.scanlistEditor.action!==''}
                        {...this.state.scanlistEditor} 
                        onAction={this.handleScanListEditorAction.bind(this)}/>
                ):'';
                console.log('scanlistDialog')
                console.log(scanlistDialog)

                list = (
                    <Grid justifyContent="flex-start" container style={{minHeight:'30vh'}}>
                        <Grid xs={6} key="1" item style={{}}>
                            <ScanListEditor  scanlists={scanlists} 
                                selectedItemID={this.state.currentScanlistID}
                                onItemSelect={this.handleScanlistSelect.bind(this)}
                                onAction={this.handleScanListEditorAction.bind(this)} /> 
                            {scanlistDialog}
                        </Grid>
                        <Grid xs={6} key="2" item style={{paddingLeft:'1em'}}>
                            <AclListEditor items={scanlistAcls} title={t('GroupName')} 
                                onChange={this.handleScanlistAclChange.bind(this)} />
                        </Grid>
                    </Grid>
                )
            }
            break;

            case 'profiles':
                const profileDialog = this.state.profileEditor.action?(
                    <EditProfileDialog open={this.state.profileEditor.action!==''}
                        {...this.state.profileEditor}  
                        onAction={this.handleProfileEditorAction.bind(this)}/>
                ):'';

                list = (
                    <>
                    <ProfilesListEditor items={profiles} 
                        selectedItemID={this.state.currentProfileID}
                        onItemSelect={this.handleProfileSelect.bind(this)}
                        onAction={this.handleProfileEditorAction.bind(this)} />  
                    {profileDialog}
                    </>
                )   
                break

            case 'dmr':{
                
                console.log('this.state.dmrUserEditor')
                console.log(this.state.dmrUserEditor)

                let dmrUserDialog = this.state.dmrUserEditor.open ? (
                    <EditDmrUserDialog {...this.state.dmrUserEditor}
                            onAction={this.handleDmrUserEditorAction.bind(this)}
                    />
                )  : ''

                list = (
                    <>
                        <FormControl>
                            <label>
                                <Checkbox color="primary" 
                                    checked={this.state.networkData.LimitDmrUsers}
                                    onChange={this.handleLimitDmrUsersChnge.bind(this)}
                                    name="Enabled"
                                    />
                                    {t('LimitDmrUsers')}
                            </label>
                        </FormControl>
                        <DmrUsersListEditor users={this.state.networkSettings.DmrUsers}
                                onAction={this.handleDmrUserEditorAction.bind(this)} />
                            {dmrUserDialog}
                    </>
                )
                break
            }

            case 'sip':{
                console.log('this.state.sipUserEditor')
                console.log(this.state.sipUserEditor)

                let buttonStyle = {margin:0, fontSize:'0.8em', marginBottom:10}

                let sipUserDialog = this.state.sipUserEditor.open ? (
                    <EditSipUserDialog {...this.state.sipUserEditor}
                            onAction={this.handleSipUserEditorAction.bind(this)}
                    />
                )  : ''

                let sipSettingsDialog = this.state.sipSettingsEditor.open ? (
                    <EditSipSettingsDialog {...this.state.sipSettingsEditor}
                        onAction={this.handleSipSettingsEditorAction.bind(this)}
                    />
                ) : ''

                list = (
                    <>
                        <Button variant='outlined' style={buttonStyle} 
                            onClick={()=>{this.handleSipSettingsEditorAction({type:'SIP_SETTINGS_EDITOR_OPEN'})}}
                            size="small">{t('SipSettings')}</Button>
                        <SipUsersListEditor users={this.state.networkSettings.SipUsers}
                                onAction={this.handleSipUserEditorAction.bind(this)} />
                            {sipUserDialog}
                            {sipSettingsDialog}
                    </>
                )
                break
            }

                 
            default:
                dev.alert('Tab action not defined! '+this.state.selectedTab)
        }

        //console.log('this.state.passwordPolicyEditor')
        //console.log(this.state.passwordPolicyEditor)
        const passwordPolicyDialog = this.state.passwordPolicyEditor.open ? (
            <EditPasswordPolicyDialog {...this.state.passwordPolicyEditor} 
                onAction={this.handleAction} />
        ):''


        const logSettingsDialog = this.state.logSettingsEditor.open ? (
            <EditLogSettingsDialog {...this.state.logSettingsEditor}
                onAction={this.handleAction}/> 
        ):''
           
        //console.log('this.state.dispatcherPermissionEditor')
        //console.log(this.state.dispatcherPermissionEditor)
        const dispatcherPermissionDialog = this.state.dispatcherPermissionEditor.open ? (
            <EditDispatcherPermissionsDialog {...this.state.dispatcherPermissionEditor}
                
                onAction={this.handleAction}/>
        ):''


        let userPermissionsDialog = this.state.userPermissionEditor.open ? (
                <EditUserPermissionsDialog {...this.state.userPermissionEditor}
                    onAction={this.handleAction}
                    />
        ) : '';



        let gridStyle = {border2:'1px solid red'}
        let gridStyle2 = {border2:'1px solid red'}
        let buttonStyle = {margin:0, width: '95%', fontSize:'0.8em'}


        let dmrEnabled = this.checkLicense('AisDmr') ||
                         this.checkLicense('CalttaDmr') ||
                         this.checkLicense('HyteraDmr') ||
                         this.checkLicense('KirisunDmr')
        //console.log('dmrEnabled')
        //console.log(dmrEnabled)

        let sipEnabled = this.checkLicense('Sip')

        const encryptionEnbled = this.checkLicense('Encryption')
        //console.log('sipEnabled')
        //console.log(sipEnabled)


        return (
            <Grid item xs={12} style={{height:'100vh'}}>

                <ApplicationBar user={this.props.user}
                    onAction={this.handleAction.bind(this)}>
                    {networkData ? networkData.Name : ''}
                </ApplicationBar>

                {passwordPolicyDialog}
                {logSettingsDialog}
                {dispatcherPermissionDialog}
                {userPermissionsDialog}

                <Grid container justifyContent="flex-start" spacing={0} style={{height:'83%', borderTop:'1px solid '+theme.palette.border.dialog}} >
                    <Grid xs={12} key="2" item style={{}}>
                        <Container height="100vh" style={{padding:0, paddingTop: '1em'}}>

                            <Dialog width="xl" variant="h6" align="left" title2={networkData.Name} style={{}}>

                            <DialogTitle id="edit-dialog-title">
                                
                                <Grid container justifyContent="flex-start"  >
                                    <Grid xs={6} key="1" item style={{}}>
                                        {networkData.Name}
                                    </Grid>
                                    <Grid xs={6} key="2" item style={{}} align="right">
                                        <Button size="small" variant="contained" color="primary" 
                                            onClick={this.handleButtonSave.bind(this)} 
                                            style={{margin: '0 0.4em'}}>{t('Apply')}</Button>
                                        <Button size="small" variant="contained" color="inherit"
                                            onClick={this.handleButtonCancel.bind(this)} 
                                            style={{margin: '0 0.4em', color:'black'}} >{t('Cancel')}</Button>
                                    </Grid>
                                </Grid>
                            
                            </DialogTitle>
                            <DialogContent>
                                
                                <Box>
                                    <Grid container justifyContent="flex-start" style={gridStyle}  >

                                        <Grid xs={4} key="1" item style={gridStyle2}>
                                            <TextField name="Name"  margin="normal"
                                                style={{width: '70%'}}
                                                label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                                                autoComplete="new-password"
                                                error={this.state.errors.Name!==false}
                                                value={networkData.Name}
                                                onChange={this.handleInput}
                                            />
                                        </Grid>
                                        <Grid xs={2} key="2" item align="center" style={gridStyle2}>
                                            <TextField name="CommandPort"  margin="normal"
                                                style={{width: '90%'}}
                                                label={this.state.errors.Name?this.state.errors.CommandPort:t('CommandPort')}
                                                autoComplete="new-password"
                                                error={this.state.errors.CommandPort!==false}
                                                value={networkData.CommandPort}
                                                onChange={this.handleInput}
                                            />
                                        </Grid>
                                        <Grid xs={2} key="3" item align="center" style={gridStyle}>
                                            <TextField name="AudioPort"  margin="normal"
                                                style={{width: '90%'}}
                                                label={this.state.errors.Name?this.state.errors.AudioPort:t('AudioPort')}
                                                autoComplete="new-password"
                                                error={this.state.errors.AudioPort!==false}
                                                value={networkData.AudioPort}
                                                onChange={this.handleInput}
                                            />
                                        </Grid>
                                        <Grid xs={2} key="4" item align="center" style={gridStyle}>
                                            <TextField name="VideoPort"  margin="normal"
                                                style={{width: '90%'}}
                                                label={this.state.errors.Name?this.state.errors.VideoPort:t('VideoPort')}
                                                autoComplete="new-password"
                                                error={this.state.errors.VideoPort!==false}
                                                value={networkData.VideoPort}
                                                onChange={this.handleInput}
                                            />
                                        </Grid>
                                        <Grid xs={2} key="5" item align="center" style={gridStyle}>
                                            <TextField name="WebSocketPort"  margin="normal"
                                                style={{width: '90%'}}
                                                label={this.state.errors.Name?this.state.errors.WebSocketPort:t('WebSocketPort')}
                                                autoComplete="new-password"
                                                error={this.state.errors.WebSocketPort!==false}
                                                value={networkData.WebSocketPort}
                                                onChange={this.handleInput}
                                            />
                                        </Grid>

                                    </Grid>

                                    <Grid container justifyContent="flex-start" style={gridStyle} >

                                        <Grid xs={4} key="1" item style={gridStyle}>
                                            {encryptionEnbled?
                                            <FormControl>
                                            <label>
                                                <Checkbox color="primary" 
                                                    checked={networkData.MediaEncryption}
                                                    onChange={this.handleInput}
                                                    name="MediaEncryption"
                                                    />
                                                    {t('Encryption')}
                                            </label>
                                            </FormControl>
                                            : null}
                                        </Grid>
                                        <Grid xs={2} key="2" item align="center" style={gridStyle}>
                                            <Button variant='outlined' style={buttonStyle} 
                                                size="small"
                                                onClick={()=>{this.handleAction({type:'SHOW_USER_PERMISSIONS_DIALOG'})}} >
                                                {t('UserPermissions')}
                                            </Button>
                                        </Grid>
                                        <Grid xs={2} key="3" item align="center" style={gridStyle}>
                                            <Button variant='outlined' style={buttonStyle} 
                                                size="small"
                                                onClick={()=>{this.handleAction({type:'SHOW_DISPATCHER_PERMISSIONS_DIALOG'})}} >
                                                {t('DispatcherPermissions')}
                                            </Button>
                                        </Grid>
                                        <Grid xs={2} key="4" item align="center" style={gridStyle}>
                                            <Button variant='outlined' style={buttonStyle} 
                                                size="small"
                                                onClick={()=>{this.handleAction({type:'SHOW_LOG_SETTINGS_DIALOG'})}} >
                                                {t('LogSettings')}
                                            </Button>
                                        </Grid>
                                        <Grid xs={2} key="5" item align="center" style={gridStyle}>
                                            <Button variant='outlined' style={buttonStyle}
                                                size="small"
                                                onClick={()=>{this.handleAction({type:'SHOW_PASSWORD_POLICY_DIALOG'})}} >{t('PasswordPolicy')}</Button>
                                        </Grid>
                                    </Grid>

                                    <Grid container justifyContent="flex-start"  style={gridStyle}>

                                        <Grid xs={4} key="1" item style={gridStyle}>
                                        </Grid>
                                        <Grid xs={4} key="2" item style={gridStyle} align="right">

                                            <FormControl>
                                            <label style={{fontSize:'small'}}>
                                                {t('EnableBatteryControl')}
                                                <Checkbox color="primary" 
                                                    checked={networkData.EnableBatteryControl}
                                                    onChange={this.handleInput}
                                                    name="EnableBatteryControl"
                                                    />
                                                    
                                            </label>
                                            </FormControl>
                                        </Grid>
                                        <Grid xs={4} key="3" item style={gridStyle}>
                                            <label style={{fontSize:'small', margin:'10px', display:'inline-block'}} 
                                                htmlFor="BatteryChargeInterval">
                                            {t('ReportBatteryLevelChangeAtEach')}
                                            </label>
                                            <TextField name="BatteryChargeInterval"  margin="normal"
                                                style={{width: '3em', margin: 0}}
                                                disabled={!networkData.EnableBatteryControl}
                                                inputProps={{name: 'BatteryChargeInterval', id: 'BatteryChargeInterval'}}
                                                hiddenLabel
                                                size="small"
                                                autoComplete="new-password"
                                                error={this.state.errors.BatteryChargeInterval!==false}
                                                value={networkData.BatteryChargeInterval}
                                                onChange={this.handleInput}
                                            />
                                        </Grid>
                                    </Grid>


                                </Box>

                                <Box textAlign="left" style={{paddingBottom: '1em'}}>
                                    <TabbedMenu 
                                        selected={this.state.selectedTab} 
                                        onClick={this.handleTabClick.bind(this)}
                                        usersEnabled={true}
                                        dispatchersEnabled={true}
                                        groupsEnabled={true}
                                        devicesEnabled={true}
                                        statusesEnabled={true}
                                        scanlistsEnabled={true}
                                        profilesEnabled={true}
                                        dmrEnabled={dmrEnabled}
                                        sipEnabled={sipEnabled}
                                    ></TabbedMenu>
                                </Box>

                                {panel ? (
                                    <Box textAlign="left" style={{margin:0, paddingBottom2: '1em'}}>
                                        {panel}
                                    </Box>
                                ) : null}

                                <Box textAlign="left" style={{paddingBottom: '1em'}}>
                                    {list}
                                </Box>

                                <Box textAlign="center" style={{}}>
                                    <Button variant="contained" color="primary" 
                                        onClick={this.handleButtonSave.bind(this)} 
                                        style={{margin: '0 0.4em'}}>{t('Apply')}</Button>
                                    <Button variant="contained" color="inherit"
                                        onClick={this.handleButtonCancel.bind(this)} 
                                        style={{margin: '0 0.4em'}} >{t('Cancel')}</Button>
                                </Box>

                            </DialogContent>
                            </Dialog>

                        </Container>
                    </Grid>
                </Grid>
                <Grid xs={12} key="2" item style={{height:'3em'}}>
                    {statusMessage}{/*Server Status*/}
                </Grid>
            </Grid>
        );
    }
}

export const NetworkEditor = withTranslation()(NetworkEditor_);